"use strict";
/**
 * This is used to ensure the csrf token is injected into all of our client side POSTS
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.head$ = exports.delete$ = exports.get$ = exports.post$ = exports.checkStatus = void 0;
var axios_1 = require("axios");
var ui_1 = require("../../actions/ui");
var constants_1 = require("../../constants");
var REQUEST_URI = constants_1.default.REQUEST_URI;
/**
 * redirects to unified login if we receive a 401 from the server, indicating the user's server session has expired.
 */
function checkStatus(response, callback) {
    var result;
    if (!response) {
        throw "Unexpected Error"; // eslint-disable-line
    }
    else if (response.status < 300) {
        result = response.data;
    }
    else if (response.status === 401) {
        // Unauthorized
        window.location.href = "/login";
    }
    else if (response.status === 307) {
        // Temporary Redirect, maybe, for risk auth
        window.location.href = response.data;
    }
    else if (response.status >= 300) {
        throw response.data;
    }
    else {
        result = response.data;
    }
    if (typeof callback === "function") {
        return callback(null, result);
    }
    else {
        return result;
    }
}
exports.checkStatus = checkStatus;
/**
 * Get data out of response object
 *
 * @param response
 */
function getData(response) {
    return response.data;
}
// Ajax POST call with spinner triggered
// store should be updated, so there is no callback needed to handle response
function post$(dispatch, _csrf, url, body, ui) {
    if (body === void 0) { body = {}; }
    var URL = window.location.protocol +
        "//" +
        window.location.host +
        REQUEST_URI +
        url;
    // start spinner
    if (ui) {
        dispatch(ui_1.updateUI(Object.assign({}, ui, { showSpinner: true })));
    }
    return axios_1.default
        .post(URL, {
        _csrf: _csrf,
        data: body,
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        },
    })
        .then(function (response) {
        if (ui) {
            // end spinner
            dispatch(ui_1.updateUI(Object.assign({}, ui, { showSpinner: false })));
        }
        window.scroll({
            top: 0,
            behavior: "smooth",
        });
        return response;
    })
        .then(getData)
        .catch(function (error) {
        if (ui) {
            // end spinner
            dispatch(ui_1.updateUI(Object.assign({}, ui, { showSpinner: false })));
        }
        window.scroll({
            top: 0,
            behavior: "smooth",
        });
        return checkStatus(error.response);
    });
}
exports.post$ = post$;
// Ajax GET call with NO spinner triggered - if later, we need spinner, then we can do as post call.
function get$(dispatch, url, ui) {
    var URL = window.location.protocol +
        "//" +
        window.location.host +
        REQUEST_URI +
        url;
    if (ui) {
        // start spinner
        dispatch(ui_1.updateUI(Object.assign({}, ui, { showSpinner: true })));
    }
    return axios_1.default
        .get(URL, {
        withCredentials: true,
        headers: { Accept: "application/json" },
    })
        .then(function (response) {
        if (ui) {
            dispatch(ui_1.updateUI(Object.assign({}, ui, { showSpinner: false })));
        }
        return response;
    })
        .then(getData)
        .catch(function (error) { return checkStatus(error.response); });
}
exports.get$ = get$;
function delete$(dispatch, _csrf, url, body, ui) {
    if (body === void 0) { body = {}; }
    var URL = window.location.protocol +
        "//" +
        window.location.host +
        REQUEST_URI +
        url;
    // start spinner
    if (ui) {
        dispatch(ui_1.updateUI(Object.assign({}, ui, { showSpinner: true })));
    }
    return axios_1.default
        .delete(URL, {
        data: body,
        headers: {
            "X-CSRF-TOKEN": _csrf,
            Accept: "application/json",
            "Content-Type": "application/json",
        },
    })
        .then(function (response) {
        if (ui) {
            // end spinner
            dispatch(ui_1.updateUI(Object.assign({}, ui, { showSpinner: false })));
        }
        return response;
    })
        .then(getData)
        .catch(function (error) {
        if (ui) {
            // end spinner
            dispatch(ui_1.updateUI(Object.assign({}, ui, { showSpinner: false })));
        }
        return checkStatus(error.response);
    });
}
exports.delete$ = delete$;
// Ajax HEAD call
function head$(url) {
    var URL = window.location.protocol +
        "//" +
        window.location.host +
        REQUEST_URI +
        url;
    return axios_1.default
        .head(URL, {
        withCredentials: true,
        headers: { Accept: "application/json" },
    })
        .catch(function (error) { return checkStatus(error.response); });
}
exports.head$ = head$;
exports.default = {
    get$: get$,
    post$: post$,
    head$: head$,
    delete$: delete$,
    checkStatus: checkStatus,
};
